import { React, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const useBuscaTextoPadraoOs = ({ formik }) => {
  const [textoPadrao, setTextoPadrao] = useState("");
  const { request: requestTextoPadraoOs, data: dataTextoPadraoOs, errors, isLoading } = useApiClient();

  const { values } = formik;

  useEffect(() => {
    if (values.sequencialTipoAcao && values.sequencialTipoAcao !== 0) {
      const parametros = { sqTipoAcaoFiscal: values.sequencialTipoAcao };
      requestTextoPadraoOs(apiRoutes.fiscalizacao.ordemservico.buscatextopadraoos, parametros);
    }
  }, [requestTextoPadraoOs, values.sequencialTipoAcao]);

  useEffect(() => {
    if (dataTextoPadraoOs) {
      setTextoPadrao(dataTextoPadraoOs.result);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [dataTextoPadraoOs, errors]);

  if (isLoading) {
    return (
      <span>
        <Spinner animation="border" role="status" />
        Carregando Texto Padrão da OS...
      </span>
    );
  }

  return { textoPadrao };
};

export default useBuscaTextoPadraoOs;
